<template>
  <b-loading class="splash" is-full-page :active="active">
    <img src="../assets/logo.png" alt="ENHANCIFY">
    <b-icon
      pack="fas"
      icon="sync-alt"
      size="is-large"
      custom-class="fa-spin">
    </b-icon>
  </b-loading>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Splash',
  computed: {
    ...mapState({
      active: (state) => state.isSplashActive,
    }),
  },
};
</script>

<style lang="stylus" scoped>
.splash
  background white !important
  & .loading-background
    background transparent
</style>
